<template>
  <div class="productList" ref="container">
    <!-- <form @submit.prevent="submitForm">
      <div class="search bg-color-red acea-row row-between-wrapper">
        <div class="input acea-row row-between-wrapper">
          <span class="iconfont icon-sousuo"></span>
          <input placeholder="搜索商品信息" v-model="where.keyword" />
        </div>
        <div
          class="iconfont"
          :class="Switch === true ? 'icon-pailie' : 'icon-tupianpailie'"
          @click="switchTap"
        ></div>
      </div>
    </form> -->
    
    <div class="nav acea-row row-middle">
      <!-- <div class="item" :class="index==0 ? 'font-color-red new' : 'line'" v-for="(item, index) in cate" :key="index" @click="toCate(item.id)">
        {{ item.cate_name }}
      </div> -->

      <div class="container" style="margin:0 auto;">
      <div class="swiper-container ">
        <swiper class="swiper-wrapper dui" :options="swiperProducts">
          <div  class="swiper-slide mar" style="width:auto;font-size: 0.3rem;border-right:1px solid #eee;padding-right:.1rem">产品分类</div>
          <swiper-slide 
                 class="item" :class="index==0 ? 'font-color-red new' : 'line'" v-for="(item, index) in cate" :key="index" @click="toCate(item.id)"
          >
            
            <div  class="swiper-slide selected" v-if="item.id == 0">产品分类</div>
            <div v-else >
              <router-link   class="swiper-slide mar" :to="{
                path: '/goods_list',
                query: { gid: item.id }
              }"
              > {{ item.cate_name }}</router-link>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    
      <!-- <div
        class="item"
        :class="nows ? 'font-color-red' : ''"
        @click="set_where(3)"
      >
        新品
      </div>
      <div class="item" @click="set_where(1)">
        价格
        <img src="@assets/images/horn.png" v-if="price === 0" />
        <img src="@assets/images/up.png" v-if="price === 1" />
        <img src="@assets/images/down.png" v-if="price === 2" />
      </div> -->
      <!-- <div
          class="iconfont"
          :class="Switch === true ? 'icon-pailie' : 'icon-tupianpailie'"
          @click="switchTap"
        ></div> -->
      <!-- down -->
    </div>
    <div
      class="list acea-row row-between-wrapper"
      :class="Switch === true ? '' : 'on'"
      ref="container"
    >
      <!-- <router-link
        :to="{
          path: '/detail/' + item.id
        }"
        class="item"
        :class="Switch === true ? '' : 'on'"
        v-for="(item, index) in productList"
        :key="index"
        :title="item.store_name"
      >
        <div class="pictrue" :class="Switch === true ? '' : 'on'">
          <img :src="item.image" :class="Switch === true ? '' : 'on'" />
        </div>
        <div class="text" :class="Switch === true ? '' : 'on'">
          <div
            class="money font-color-red"
            :class="Switch === true ? '' : 'on'"
          >
            ￥<span class="num">{{ item.price }}</span>
            <div class="label">包邮</div>
            <div class="sale">已售{{ item.sales }}件</div>
          </div>
          <div
            class="vip acea-row row-between-wrapper"
            :class="Switch === true ? '' : 'on'"
          >
            <div class="vip-money" v-if="item.vip_price && item.vip_price > 0">
              ￥{{ item.vip_price }}<img src="@assets/images/vip.png" />
            </div>
          </div>
        <div class="name line1">{{ item.store_name }}</div>
        </div>
      </router-link> -->
      <router-link :to="{
          path: item.wap_link
        }" v-for="(item, index) in recommend" :key="index">
      <div class="poster"><img :src="item.pic" /></div>
      </router-link>

    </div>
    <!-- <Loading :loaded="loadend" :loading="loading"></Loading> -->
    <div
      class="noCommodity"
      v-cloak
      style="background-color: #fff;"
      v-if="productList.length === 0 && where.page > 1"
    >
      <div class="noPictrue">
        <img src="@assets/images/noGood.png" class="image" />
      </div>
    </div>
    <Recommend v-if="productList.length === 0 && where.page > 1"></Recommend>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Recommend from "@components/Recommend";
import { getProducts } from "@api/store";
import { getIndexRecommend } from "@api/public";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";

export default {
  name: "GoodsList",
  components: {
    swiper,
    swiperSlide,
    Recommend,
    Loading
  },
  props: {},
  data: function() {
    const { s = "", id = 0, title = "" } = this.$route.query;

    return {
      peepUrl: "http://tieyige.fsrcwl.cn/images/yinsi.png",
      fatigueUrl: "http://tieyige.fsrcwl.cn/images/yufang.png",
      hostProduct: [],
      productList: [],
      Switch: true,
      where: {
        page: 1,
        limit: 8,
        keyword: s,
        sid: id, //二级分类id
        news: 0,
        priceOrder: "",
        salesOrder: ""
      },
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      title: title && id ? title : "",
      loadTitle: "",
      loading: false,
      loadend: false,
      price: 0,
      stock: 0,
      nows: false,
      recommend: [],
      cate: []
    };
  },
  watch: {
    title() {
      this.updateTitle();
    },
    $route(to) {
      // if (to.name !== "GoodsList") return;
      // const { s = "", id = 0, title = "" } = to.query;

      // if (s !== this.where.keyword || id !== this.where.sid) {
        // this.where.keyword = s;
        // this.loadend = false;
        // this.loading = false;
        // this.where.page = 1;
        // this.where.sid = 0;
        // this.title = "";
        // this.nows = false;
        // this.$set(this, "productList", []);
        // this.price = 0;
        // this.stock = 0;
        // this.get_product_list();
      // }
    }
  },
  mounted: function() {
    this.updateTitle();
    this.get_index_recommend();
    // this.get_product_list();
    // this.$scroll(this.$refs.container, () => {
    //   !this.loading && this.get_product_list();
    // });
  },
  methods: {
    updateTitle() {
      document.title = this.title || this.$route.meta.title;
    },
    get_index_recommend: debounce(function() {
      var that = this;
      getIndexRecommend().then(res=>{
        that.recommend = res.data.activity;
        that.cate = res.data.cate;
      });
    }, 300),
    toCate:function(id){
      let that = this;
      return that.$router.push({ path: "/category",query: { tocateid: id } });
    },
    get_product_list: debounce(function() {
      var that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      // this.setWhere();
      let q = that.where;
      getProducts(q).then(res => {
        that.loading = false;
        that.productList.push.apply(that.productList, res.data);
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
      });
    }, 300),
    submitForm: function() {
      this.$set(this, "productList", []);
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.get_product_list();
    },
    //点击事件处理
    set_where: function(index) {
      let that = this;
      switch (index) {
        case 0:
          return that.$router.push({ path: "/category" });
        case 1:
          if (that.price === 0) that.price = 1;
          else if (that.price === 1) that.price = 2;
          else if (that.price === 2) that.price = 0;
          that.stock = 0;
          break;
        case 2:
          if (that.stock === 0) that.stock = 1;
          else if (that.stock === 1) that.stock = 2;
          else if (that.stock === 2) that.stock = 0;
          that.price = 0;
          break;
        case 3:
          that.nows = !that.nows;
          break;
        default:
          break;
      }
      that.$set(that, "productList", []);
      that.where.page = 1;
      that.loadend = false;
      that.get_product_list();
    },
    //设置where条件
    setWhere: function() {
      let that = this;
      if (that.price === 0) {
        that.where.priceOrder = "";
      } else if (that.price === 1) {
        that.where.priceOrder = "asc";
      } else if (that.price === 2) {
        that.where.priceOrder = "desc";
      }
      if (that.stock === 0) {
        that.where.salesOrder = "";
      } else if (that.stock === 1) {
        that.where.salesOrder = "asc";
      } else if (that.stock === 2) {
        that.where.salesOrder = "desc";
      }
      that.where.news = that.nows ? "1" : "0";
    },
    switchTap: function() {
      let that = this;
      that.Switch = !that.Switch;
    }
  }
};
</script>
<style scoped>
.noCommodity {
  border-top: 3px solid #f5f5f5;
  padding-bottom: 1px;
}
.list .poster{
  width: 100%;
  margin:.3rem 0 0;
}
.list .poster img{
  width: 100%;
  height: 100%;
}
.productList .nav{
  height: .96rem;
}
/* .productList .nav .item{
    width: 26%;
    font-size:.3rem;
    position: relative;
    margin-bottom:unset;
} */
/* .productList .nav .new{
    font-size: .35rem;
    color:#df7251!important;
    font-weight: bold;
    margin-bottom:unset;
    margin-right:.2rem;
}

.selected{color:#df7251!important;} */
.font-color-red{color: unset!important;}
a{color:unset;}
.productList .nav .line::before{
    content: '';
    width:1px;
    height: 20px;
    background-color:#eee;
    position: absolute;
    left: 0;
}
.index .nav .item{
      margin-bottom: unset;
      /* margin-top: .2rem; */
      padding:0 .1rem;
      width: 30%;
      font-size: 0.3rem;
}

.productList .nav{
    position: relative;
    top: 0;
    margin: .1rem 0 0;
}
.productList .nav .iconfont{
  position: absolute;
  top:28%;
  right:3.5%;
  font-size:.38rem
}
.productList .list{
    margin-top: unset;
}
.index .nav{padding-top:unset}
/* .mar{margin-top:.2rem;} */
.dui{align-items: baseline!important;}
.productList .nav .item{
  width:auto!important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}
</style>
